import React from 'react';
import AsyncSelect from 'react-select/async';
import { useTranslation } from "react-i18next";

const ProductSelect = ({
  value,
  onChange,
  loadOptions,
  quantity,
  setQuantity,
  price,
  setPrice,
  vat,
  setVat,
  vatOptions,
  onAdd,
  disabled
}) => {
  const { t } = useTranslation();
  return (
    <section style={{ marginBottom: 32 }}>
      <h2 style={{ fontSize: 22, color: '#1976d2', marginBottom: 12, fontWeight: 600 }}>
        {t("product")}
      </h2>
      <AsyncSelect
        cacheOptions
        loadOptions={loadOptions}
        defaultOptions
        isClearable
        onChange={onChange}
        value={value}
        placeholder={t("search_product_placeholder")}
        noOptionsMessage={() => t("no_products_found") || "No products found"}
        loadingMessage={() => t("loading") || "Loading..."}
        styles={{
          container: base => ({ ...base, marginBottom: 8, width: '100%' }),
          menu: base => ({ ...base, zIndex: 9999 })
        }}
      />
      {value && (
        <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 16 }}>
          <label>
            {t("quantity")}:
            <input
              type="number"
              min={1}
              value={quantity}
              onChange={e => setQuantity(Number(e.target.value))}
              style={{
                width: 60,
                marginLeft: 6,
                padding: '6px 8px',
                borderRadius: 4,
                border: '1px solid #b0b6c7',
                fontSize: 15,
              }}
            />
          </label>
          <label>
            {t("price")}:
            <input
              type="number"
              value={price}
              onChange={e => setPrice(Number(e.target.value))}
              style={{
                width: 80,
                marginLeft: 6,
                padding: '6px 8px',
                borderRadius: 4,
                border: '1px solid #b0b6c7',
                fontSize: 15,
              }}
            />
          </label>
          <button
            type="button"
            disabled={disabled}
            style={{
              marginLeft: 16,
              background: disabled ? '#b0b6c7' : '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '8px 18px',
              fontWeight: 600,
              fontSize: 15,
              cursor: disabled ? 'not-allowed' : 'pointer',
              boxShadow: '0 2px 8px #e3e6f0',
              transition: 'background 0.2s',
            }}
            onClick={onAdd}
          >
            {t("add_to_invoice")}
          </button>
        </div>
      )}
    </section>
  );
};

export default ProductSelect;